module.exports = __webpack_public_path__ + "static/media/poster_2.4d83ac2d.png";